import styled from 'styled-components';

export const ProductListHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
`;
